import { render, staticRenderFns } from "./addFixedAsset.vue?vue&type=template&id=13393a6e&scoped=true&"
import script from "./addFixedAsset.vue?vue&type=script&lang=js&"
export * from "./addFixedAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13393a6e",
  null
  
)

export default component.exports